import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DocumentViewerEffects } from './document-viewer.effects';
import { reducer } from './document-viewer.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('documentViewer', reducer),
    EffectsModule.forFeature([DocumentViewerEffects]),
  ],
  providers: [DocumentViewerEffects],
})
export class DocumentViewerStoreModule {}
